/* tslint:disable */
/* eslint-disable */
/* @relayHash a3f6b4ccea593f4099d35643f621cc67 */

import { ConcreteRequest } from "relay-runtime";
export type RequestBackgroundCheckLoaderQueryVariables = {};
export type RequestBackgroundCheckLoaderQueryResponse = {
    readonly manager: {
        readonly firstName: string;
        readonly lastName: string;
        readonly company: {
            readonly name: string;
            readonly backgroundCheckPennyPrice: number;
            readonly dbsPennyPrice: number;
            readonly dbsOnlyPennyPrice: number;
            readonly renewalPennyPrice: number;
            readonly invoicing: {
                readonly dbsUsed: number;
                readonly dbsPrePurchased: number;
                readonly backgroundChecksUsed: number;
                readonly backgroundChecksPrePurchased: number;
                readonly renewalsUsed: number;
                readonly renewalsPrePurchased: number;
            } | null;
        };
    } | null;
};
export type RequestBackgroundCheckLoaderQuery = {
    readonly response: RequestBackgroundCheckLoaderQueryResponse;
    readonly variables: RequestBackgroundCheckLoaderQueryVariables;
};



/*
query RequestBackgroundCheckLoaderQuery {
  manager {
    firstName
    lastName
    company {
      name
      backgroundCheckPennyPrice
      dbsPennyPrice
      dbsOnlyPennyPrice
      renewalPennyPrice
      invoicing {
        dbsUsed
        dbsPrePurchased
        backgroundChecksUsed
        backgroundChecksPrePurchased
        renewalsUsed
        renewalsPrePurchased
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "manager",
            "storageKey": null,
            "args": null,
            "concreteType": "Manager",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "firstName",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "lastName",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "company",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Company",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "name",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "backgroundCheckPennyPrice",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "dbsPennyPrice",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "dbsOnlyPennyPrice",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "renewalPennyPrice",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "invoicing",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CompanyInvoicing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "dbsUsed",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "dbsPrePurchased",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "backgroundChecksUsed",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "backgroundChecksPrePurchased",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "renewalsUsed",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "renewalsPrePurchased",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "RequestBackgroundCheckLoaderQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": (v0 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "RequestBackgroundCheckLoaderQuery",
            "argumentDefinitions": [],
            "selections": (v0 /*: any*/)
        },
        "params": {
            "operationKind": "query",
            "name": "RequestBackgroundCheckLoaderQuery",
            "id": null,
            "text": "query RequestBackgroundCheckLoaderQuery {\n  manager {\n    firstName\n    lastName\n    company {\n      name\n      backgroundCheckPennyPrice\n      dbsPennyPrice\n      dbsOnlyPennyPrice\n      renewalPennyPrice\n      invoicing {\n        dbsUsed\n        dbsPrePurchased\n        backgroundChecksUsed\n        backgroundChecksPrePurchased\n        renewalsUsed\n        renewalsPrePurchased\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '6bbeb6e531cf4d7c23cfbec42884b78c';
export default node;
